import * as tslib_1 from "tslib";
import { FormBuilder, Validators } from '@angular/forms';
import { StorageService } from 'src/app/root/_services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/root/_services/language.service';
import { AlertService } from 'src/app/root/_services/alert.service';
import { AuthenticationService } from 'src/app/root/_services/authentication.service';
import { UserService } from 'src/app/root/_services/user.service';
import { delay, first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { SaveTempService } from 'src/app/root/_services/save-temp.service';
import { CheckProfileService } from 'src/app/root/_services/check-profile.service';
import { AppConfig } from 'src/app/app.config';
import { BaseController } from 'src/app/shared/base-controller';
var LoginComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LoginComponent, _super);
    function LoginComponent(fb, storageService, translateService, languageService, alertService, authenticationService, usersService, router, saveTempService, checkprofileService, route, config) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.storageService = storageService;
        _this.translateService = translateService;
        _this.languageService = languageService;
        _this.alertService = alertService;
        _this.authenticationService = authenticationService;
        _this.usersService = usersService;
        _this.router = router;
        _this.saveTempService = saveTempService;
        _this.checkprofileService = checkprofileService;
        _this.route = route;
        _this.config = config;
        _this.forceValidation = false;
        _this.storageService.clearLocal("access_token");
        _this.storageService.clear("access_token");
        return _this;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.versione = this.config.getVersion("semverString");
        this.createForm();
        this.loadLanguages();
        //this.loadLabels();
        this.checkLoginRemember();
        this.fromActivate = this.route.snapshot.queryParams["a"];
        this.authenticationService.getBackendVersion().subscribe(function (x) {
            if (x.status == "OK")
                _this.versioneBE = x.result;
            else
                _this.alertService.error(x.error_message ? x.error_message : "System error");
        });
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || null;
    };
    // loadLabels() {
    // 	this.label = this.translateService.instant([
    // 		"login.inserire_la_mail",
    // 		"login.invio_mail_password_dimenticata",
    // 		"login.dati_di_accesso_non_validi"
    // 	]);
    // 	console.log(this.label);
    // }
    LoginComponent.prototype.checkLoginRemember = function () {
        var _this = this;
        var rememberToken = this.storageService.getItemLocalPlain("access_token");
        if (rememberToken) {
            this.subs.push(this.authenticationService.loginRemember(rememberToken)
                .pipe(first())
                .subscribe(function (data) { return _this.afterLogin(data); }));
        }
        else {
            this.saveTempService.empty();
            this.authenticationService.logout(false).pipe(delay(0));
        }
    };
    LoginComponent.prototype.createForm = function () {
        this.loginFormGroup = this.fb.group({
            "email": ["", [Validators.required, Validators.email]],
            "password": ["", Validators.required],
            "remember": [false],
            "mkt": "",
            "profilo": "P",
            "returnUrl": [""]
        });
    };
    LoginComponent.prototype.loadLanguages = function () {
        var _this = this;
        this.subs.push(this.languageService.getAll()
            .subscribe(function (data) {
            if (data.status == "OK")
                _this.listLanguages = _this.languageService.mapLanguages(data.result.data);
            else {
                _this.alertService.error(data.error_message);
                _this.listLanguages = [];
            }
        }, function (error) {
            _this.alertService.error(error);
        }));
    };
    LoginComponent.prototype.onSubmit = function () {
        this.forgot = false;
        this.forceValidation = false;
        if (this.canSubmit())
            this.login();
        else
            this.forceValidation = true;
    };
    LoginComponent.prototype.register = function () {
        this.router.navigate(["/register"]);
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        this.loginFormGroup.patchValue({ "returnUrl": this.returnUrl });
        this.subs.push(this.authenticationService.login(this.loginFormGroup.value).subscribe(function (data) { return _this.afterLogin(data); }));
    };
    LoginComponent.prototype.afterLogin = function (data) {
        if (data.status === 'OK' && data.result && data.result.jwt)
            this.checkprofileService.getMessages();
        else if (data.status === 'OK')
            this.alertService.error(this.translateService.instant("login.dati_di_accesso_non_validi"));
        else {
            this.alertService.error(data.error_message);
            this.saveTempService.empty();
            this.authenticationService.logout(false).pipe(delay(0));
        }
    };
    LoginComponent.prototype.canSubmit = function () {
        return this.loginFormGroup.valid && this.loginFormGroup.dirty;
    };
    LoginComponent.prototype.useLanguage = function (language) {
        this.storageService.storePlain('language', language);
        this.translateService.use(language);
    };
    LoginComponent.prototype.forgotPassword = function () {
        var _this = this;
        this.forgot = true;
        if (this.loginFormGroup.get("email").errors) {
            this.alertService.error(this.translateService.instant("login.inserire_la_mail"));
            return;
        }
        this.subs.push(this.usersService.forgotPassword(this.loginFormGroup.get("email").value)
            .subscribe(function (data) {
            if (data.status == "OK") {
                _this.alertService.success(_this.translateService.instant("login.invio_mail_password_dimenticata"));
                _this.forgot = false;
            }
            else
                _this.alertService.error(data.error_message);
        }, function (error) {
            _this.alertService.error(error);
        }));
    };
    return LoginComponent;
}(BaseController));
export { LoginComponent };
